/**
 * @method setAlertModal
 */
export function ModalController () {
    this.alertModal = null;
    this.loadingModal = null;
    this.confirmModal = null;
    this.otpModal = null;
    this.termsModal = null;
    this.confirmRedeemModal = null;
    this.shippingModal = null;
    this.serialModal = null;
    this.registerSuccessModal = null;
    this.confirmSurpriseModal = null;
    this.marketingModal = null;
    this.marketingRegisterModal = null;
    this.ageConsentModal = null;
    this.verifyCodeModal = null;
    this.successModal = null;

    this.cookieModal = null;
    this.cookieConsentModal = null;
    this.subcampaignModal = null;
    this.addToCartModal = null;

    this.setAlertModal = function(alertModalController) {
        this.alertModal = alertModalController;
    };

    this.setLoadingModal = function(loadingModalController) {
        this.loadingModal = loadingModalController;
    };

    this.setConfirmModal = function(confirmModalController) {
        this.confirmModal = confirmModalController;
    };

    this.setOTPModal = function (otpModalController) {
        this.otpModal = otpModalController;
    };

    this.setTermsModal = function (termsModalController) {
        this.termsModal = termsModalController;
    };

    this.setConfirmRedeemModal = function (confirmRedeemModal) {
        this.confirmRedeemModal = confirmRedeemModal;
    };

    this.setShippingModal = function (shippingModalController) {
        this.shippingModal = shippingModalController;
        if (this.alertModal) {
            this.shippingModal.setAlertModal(this.alertModal);
        }
        if (this.confirmModal) {
            this.shippingModal.setConfirmModal(this.confirmModal);
        }
        if (this.loadingModal) {
            this.shippingModal.setLoadingModal(this.loadingModal);
        }
    };

    this.setSerialModal = function (serialModalController) {
        this.serialModal = serialModalController;
        if (this.loadingModal) {
            this.serialModal.setLoadingModal(this.loadingModal);
        }
    };

    this.setRegisterSuccessModal = function (registerSuccessModal) {
        this.registerSuccessModal = registerSuccessModal;
    };

    this.setConfirmSurpriseModal = function (confirmSurpriseModal) {
        this.confirmSurpriseModal = confirmSurpriseModal;
    };
    this.setMarketingModal = function (marketingModal) {
        this.marketingModal = marketingModal;
        if (this.alertModal) {
            this.marketingModal.setAlertModal(this.alertModal);
        }
    };
   
    this.setMarketingRegisterModal = function (marketingRegisterModal) {
        this.marketingRegisterModal = marketingRegisterModal;
        if (this.alertModal) {
            this.marketingRegisterModal.setAlertModal(this.alertModal);
        }
        if (this.confirmModal) {
            this.marketingRegisterModal.setConfirmModal(this.confirmModal);
        }
        if (this.loadingModal) {
            this.marketingRegisterModal.setLoadingModal(this.loadingModal);
        }
    };
    this.setAgeConsentModal = function (ageConsentModal) {
        this.ageConsentModal = ageConsentModal;
    }

    this.setVerifyCodeModal = function (verifyCodeModalController) {
        this.verifyCodeModal = verifyCodeModalController;
    }

    this.setSuccessModal = function (successModalController) {
        this.successModal = successModalController;
    }

    this.setCookieConsentModal = function (cookieConsentModal) {
        this.cookieConsentModal = cookieConsentModal;
        // if (this.alertModal) {
        //     this.marketingModal.setAlertModal(this.alertModal);
        // }
    };
    
    this.setCookieModal = function (cookieModal) {
        this.cookieModal = cookieModal;

        if (this.cookieConsentModal) {
            this.cookieModal.setCookieConsentModal(this.cookieConsentModal);
        }

        if (this.alertModal) {
            this.cookieModal.setAlertModal(this.alertModal);
        }

        if (this.confirmModal) {
            this.cookieModal.setConfirmModal(this.confirmModal);
        }
    };

    this.setAddToCartModal = function (addToCartModal) {
        this.addToCartModal = addToCartModal;
    }

    this.setSubcampaignModal = function (subcampaignModal) {
        this.subcampaignModal = subcampaignModal;
    }

    
}
